module.exports = class Gallery {
  constructor() {
    $(".gallery").lightGallery();
  }
}
